import axiosInstance from "../../services/axiosInstance";

export const genProcessDataOfJpPay = async (
  d: JpPayRequestDTO,
  isTest?: boolean,
) => {
  const response = await axiosInstance.post(
    isTest
      ? "/gateway/payment/jppay/gen-process-data/test"
      : "/gateway/payment/jppay/gen-process-data",
    d,
  );
  return response.data.result;
};

export const genProcessDataFromBookingOfJpPay = async (d: {
  jpPayRequest: JpPayRequestDTO;
  bookingRequests: BookingRequestDTO[];
}) => {
  const response = await axiosInstance.post(
    "/gateway/payment/jppay/gen-process-data-from-booking",
    d,
  );
  return response.data.result;
};

export const genProcessDataOfSquarePay = async () => {
  const response = await axiosInstance.post(
    "/gateway/payment/squarepay/gen-process-data",
  );
  return response.data.result;
};
